import { MapContainer } from '@ais-ui/react-openlayers';
import { ReactNode, useState } from 'react';

export interface MapProps {
  center?: [number, number] | undefined;
  zoom?: number | undefined;
  className?: string;
  children?: ReactNode;
  olMapRef?: React.MutableRefObject<any>; // Access to map outside provider
}

export function Map(props: MapProps) {
  const [zoom, setZoom] = useState(props.zoom || 7);
  const [center, setCenter] = useState(props.center || [11, 59]);

  return (
    <MapContainer
      olMapRef={props.olMapRef}
      zoom={zoom}
      setZoom={setZoom}
      center={center}
      setCenter={setCenter}
      className={props.className}
    >
      {props.children}
    </MapContainer>
  );
}

export default Map;
